import type { UserLifecycleEvent, UserLifecycleEventType } from '~/services/api/generated'

/** Timestamp of the first lifecycle event of `type` with a non-blank timestamp, else undefined. */
export function findLifecycleOccurredAt(
  user: { readonly lifecycle: readonly UserLifecycleEvent[] } | null | undefined,
  type: UserLifecycleEventType
): string | undefined {
  return user?.lifecycle.find((event) => event.type === type && event.occurred_at.trim() !== '')
    ?.occurred_at
}
